bovoApp.controller('PackageTypeController', ['$scope', 'PackageType', '$location', '$routeParams', '$filter', '$translate',
  function ($scope, PackageType, $location, $routeParams, $filter, $translate) {
    $scope.deleted = [];


    $scope.all = function () {
      PackageType.all($scope.type).success(function (data, status, headers, config) {
        $scope.data = data;
      });
    }

    $scope.openDetail = function (item) {
      PackageType.get(item.id).success(function (data, status, headers, config) {
        $('#packageTypeModal').modal('show');
        $scope.packageType = data.packageType;
      });
    }

    $scope.$on('new_data', function () {
      $('#packageTypeModal').modal('show');
      $scope.new();
    }, true);

    $scope.new = function () {
      PackageType.new().success(function (data, status, headers, config) {
        $scope.packageType = {
        };
      });
    }

    $scope.delete = function (type) {
      if (type == 'set') {
        $('#delete').modal('show');
      } else if (type == 'delete') {
        PackageType.delete($scope.deleted).success(function (data, status, headers, config) {
          Messenger().post($scope.translate(data.message.toString()));
          for (var i = $scope.deleted.length - 1; i >= 0; i--) {
            var index = $scope.data.packageTypes.indexOf($filter('filter')($scope.data.packageTypes, {
              id: $scope.deleted[i]
            })[0]);
            if (index > -1) {
              $scope.data.packageTypes.splice(index, 1);
            }
          }
          $scope.deleted = [];
          $('#delete').modal('hide');
        }).error(function (data) {
          Messenger().post({
            message: data.message,
            type: "error"
          });
        });
      }
    }

    $scope.postForm = function (user) {
      if ($scope.packageType.id) {
        $scope.update();
      } else {
        $scope.save();
      }
    }

    $scope.save = function () {
      PackageType.save($scope.packageType).success(function (data, status, headers, config) {
        $scope.data = data;
        Messenger().post('Başarılı');
        $('#packageTypeModal').modal('hide');
        $scope.all();
      }).error(function (data) {
        Messenger().post({
          message: data.message,
          type: "error"
        });
      });
    }

    $scope.update = function () {
      PackageType.update($scope.packageType).success(function (data, status, headers, config) {
        $scope.data = data;
        Messenger().post('Başarılı');
        $('#packageTypeModal').modal('hide');
        $scope.all();
      }).error(function (data) {
        Messenger().post({
          message: data.message,
          type: "error"
        });
      });
    }

    $scope.toggleSelection = function toggleSelection(id) {
      var idx = $scope.deleted.indexOf(id);
      if (idx > -1) {
        $scope.deleted.splice(idx, 1);
      } else {
        $scope.deleted.push(id);
      }
    };

  }
]);